// Wait for jQuery to be available before running jQuery-dependent code
(function waitForJQuery() {
    if (typeof jQuery === 'undefined' || typeof $ === 'undefined') {
        setTimeout(waitForJQuery, 50);
        return;
    }
    
    // Now run the rest of the jQuery-dependent code
    // Use jQuery instead of $ to be safe
    jQuery(document).ready(function($) {
    $('body :not(script)').contents().filter(function() {
      return this.nodeType === 3;
    }).each(function() {
      // Replace the symbols with a string containing <sup> tags
      var replacedText = this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
      // Parse the HTML so it is inserted as HTML, not as plain text
      $(this).replaceWith($.parseHTML(replacedText));
    });
  
    // Redirect /collections and /collections/all to wood-pellet-1
    if (['/collections', '/collections/all', '/collections/'].includes(window.location.pathname)) {
        window.location.href = '/collections/wood-pellet';
    }
  
    // Original array of paths
    const categoryPaths = [
        '/pages/recipes',
        '/pages/beef',
        '/pages/poultry',
        '/pages/pork',
        '/pages/vegetables',
        '/pages/seafood',
        '/pages/wild-game',
        '/pages/grill',
        '/pages/griddle',
        '/pages/smoke',
        '/pages/bbq',
        '/pages/bake',
        '/pages/braise',
        '/pages/roast',
        '/pages/regional-bbq',
        '/pages/appetizers',
        '/pages/breakfast',
        '/pages/lunch',
        '/pages/dinner',
        '/pages/sides',
        '/pages/extras',
        '/pages/drinks',
        '/pages/quick-and-easy',
        '/pages/desserts',
        '/pages/leftover-ideas',
        '/pages/kid-friendly',
        '/pages/christmas',
        '/pages/thanksgiving',
        '/pages/date-night',
        '/pages/backyard-bbqs',
        '/pages/tailgating',
        '/pages/july-4th',
        '/pages/easter',
        '/pages/cinco-de-mayo',
        '/pages/st-patricks-day',
        '/pages/mothers-day',
        '/pages/fathers-day',
        '/pages/national-hot-dog-day',
        '/pages/national-wing-day'
    ];
  
    // Extract categories from paths
    const categories = categoryPaths.map(path => path.split('/').pop());
  
    // Create a category map
    const categoryMap = categories.reduce((acc, category) => {
        acc[category] = `/pages/${category}`;
        return acc;
    }, {});
  
    // Capture referrer
    const referrer = document.referrer;
    const refCategory = categoryPaths.find(path => referrer.includes(path));
  
    // Extract the category name from the referrer and store it in session storage
    if (refCategory) {
        const categoryName = refCategory.split('/').pop();
        console.log('User came from category:', categoryName);
        sessionStorage.setItem('lastRecipeCategory', categoryName);
    }

    // View Recipe Button Centering - Works on Mobile and Desktop
    let processedButtons = new Set(); // Track processed buttons to prevent duplicates
    let lastScreenWidth = window.innerWidth; // Track screen width changes
    
    function centerMobileButtons() {
        // Clear processed buttons if screen width changed
        if (window.innerWidth !== lastScreenWidth) {
            processedButtons.clear();
            lastScreenWidth = window.innerWidth;
        }
        
        // Find only promo blocks within the specific recipe section (not mosaic)
        // Look for promo-grid--height-small that contains recipe-related content
        const allSections = document.querySelectorAll('.promo-grid--height-small');
        let targetSection = null;
        
        // Find the section that contains recipe blocks (not mosaic)
        for (let section of allSections) {
            const promoBlocks = section.querySelectorAll('.promo-grid--inner .promo-block');
            if (promoBlocks.length > 0) {
                const firstBlock = promoBlocks[0];
                // Check if this is a recipe section (not mosaic)
                if (!firstBlock.classList.contains('promo-mosaic--maintain-aspect-ratio')) {
                    // Check if it contains recipe-related content (pxu-lia-element is added by animation script, so fallback to promo-block--button)
                    const button = firstBlock.querySelector('span.button-outline.promo-block--button.pxu-lia-element') || firstBlock.querySelector('span.button-outline.promo-block--button');
                    if (button && button.textContent.trim().toLowerCase().includes('recipe')) {
                        targetSection = section;
                        break;
                    }
                }
            }
        }
        
        if (!targetSection) {
            return;
        }
        
        const promoBlocks = targetSection.querySelectorAll('.promo-grid--inner .promo-block');
        
        promoBlocks.forEach((block, blockIndex) => {
            // Find the content wrapper within each block
            const contentWrapper = block.querySelector('.promo-block--content-wrapper');
            if (!contentWrapper) {
                return;
            }
            
            // Find the button (pxu-lia-element may be added later by animation script)
            const button = contentWrapper.querySelector('span.button-outline.promo-block--button.pxu-lia-element') || contentWrapper.querySelector('span.button-outline.promo-block--button');
            if (!button) {
                return;
            }
            
            // Create unique identifier for this button
            const buttonId = button.textContent.trim() + '_' + blockIndex;
            if (processedButtons.has(buttonId)) {
                return;
            }
            
            // Double-check that this button is actually within our target section
            if (!targetSection.contains(button)) {
                return;
            }
            
            // Apply flexbox to the content wrapper
            contentWrapper.style.setProperty('display', 'flex', 'important');
            contentWrapper.style.setProperty('flex-direction', 'column', 'important');
            contentWrapper.style.setProperty('justify-content', 'space-between', 'important');
            contentWrapper.style.setProperty('height', '100%', 'important');
            contentWrapper.style.setProperty('min-height', '300px', 'important'); // Ensure minimum height
            contentWrapper.style.setProperty('flex-grow', '1', 'important'); // Take up available space
            
            // Also ensure the parent content has proper height
            const content = block.querySelector('.promo-block--content');
            if (content) {
                content.style.setProperty('height', '100%', 'important');
                content.style.setProperty('display', 'flex', 'important');
                content.style.setProperty('flex-direction', 'column', 'important');
                content.style.setProperty('min-height', '300px', 'important'); // Ensure minimum height
            }
            
            // Apply centering styles to the button
            button.style.setProperty('text-align', 'center', 'important');
            button.style.setProperty('position', 'relative', 'important');
            button.style.setProperty('bottom', '0', 'important');
            
            // Full width button at bottom for all screen sizes
            button.style.setProperty('margin-top', 'auto', 'important'); // This pushes to bottom
            button.style.setProperty('width', '100%', 'important');
            button.style.setProperty('display', 'block', 'important');
            
            // Mark this button as processed
            processedButtons.add(buttonId);
        });
        
        // Now apply 200px width to all OTHER buttons on the page (not recipe buttons) - MOBILE ONLY
        if (window.innerWidth <= 719) {
            const allOtherButtons = document.querySelectorAll('span.button-outline.promo-block--button');
            allOtherButtons.forEach((button, index) => {
                // Skip if this button is within our target recipe section
                if (targetSection.contains(button)) {
                    return;
                }
                
                // Create unique identifier for this button
                const buttonId = button.textContent.trim() + '_other_' + index;
                if (processedButtons.has(buttonId)) {
                    return;
                }
                
                // Apply 200px width to other buttons on mobile only
                button.style.setProperty('width', '200px', 'important');
                button.style.setProperty('display', 'inline-block', 'important');
                button.style.setProperty('text-align', 'center', 'important');
                
                // Mark this button as processed
                processedButtons.add(buttonId);
            });
        } else {
            // On desktop, reset other buttons to their default styling
            const allOtherButtons = document.querySelectorAll('span.button-outline.promo-block--button');
            allOtherButtons.forEach((button, index) => {
                // Skip if this button is within our target recipe section
                if (targetSection.contains(button)) {
                    return;
                }
                
                // Create unique identifier for this button
                const buttonId = button.textContent.trim() + '_other_' + index;
                if (processedButtons.has(buttonId)) {
                    return;
                }
                
                // Reset to default styling on desktop - remove all custom styles
                button.style.removeProperty('width');
                button.style.removeProperty('display');
                button.style.removeProperty('text-align');
                
                // Mark this button as processed
                processedButtons.add(buttonId);
            });
        }
    }

    // Apply on load and resize (throttled for better mobile Safari performance)
    centerMobileButtons();
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(centerMobileButtons, 100);
    });

    // Run once more after a short delay to catch any late-loading content
    setTimeout(centerMobileButtons, 1000);
    
    // Also apply when new content is loaded (for dynamic content)
    const observer = new MutationObserver(function(mutations) {
        let shouldProcess = false;
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Check if any new promo blocks were added
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        if (node.classList && node.classList.contains('promo-block')) {
                            shouldProcess = true;
                        } else if (node.querySelector && node.querySelector('.promo-block')) {
                            shouldProcess = true;
                        }
                    }
                });
            }
        });
        
        if (shouldProcess) {
            setTimeout(centerMobileButtons, 100);
        }
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Note: sortOutOfStockProducts is now in its own file: sort-out-of-stock-products.js

    // Fix accessibility issue: Hidden iframes with interactive content
    // If an iframe is marked as aria-hidden but contains interactive elements,
    // we need to ensure it's not focusable via keyboard navigation
    function fixHiddenIframeAccessibility() {
        // Find all iframes that are marked as hidden
        const hiddenIframes = document.querySelectorAll('iframe[aria-hidden="true"], iframe.hidden, iframe[class*="hidden"]');
        
        hiddenIframes.forEach(function(iframe) {
            // Ensure the iframe itself is not focusable via keyboard
            // This prevents users from tabbing to it, which would cause screen reader silence
            iframe.setAttribute('tabindex', '-1');
            
            // If the iframe has aria-hidden, ensure it's properly configured
            // Note: We can't access iframe content due to cross-origin restrictions,
            // but we can ensure the iframe frame itself is not accessible via keyboard
            if (iframe.getAttribute('aria-hidden') === 'true') {
                // Mark as presentation role to reinforce that it's decorative/functional but not interactive
                iframe.setAttribute('role', 'presentation');
                
                // Ensure it's visually hidden and not in tab order
                // Don't disable pointer events as the iframe may need to function in background
                // (e.g., Shop Pay cart sync needs to communicate but shouldn't be focusable)
            }
        });
    }
    
    // Run on page load
    fixHiddenIframeAccessibility();
    
    // Also watch for dynamically added iframes (like Shop Pay cart sync)
    const iframeObserver = new MutationObserver(function(mutations) {
        let shouldFix = false;
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        // Check if the added node is a hidden iframe
                        if (node.tagName === 'IFRAME' && 
                            (node.getAttribute('aria-hidden') === 'true' || 
                             node.classList.contains('hidden') ||
                             node.hasAttribute('hidden'))) {
                            shouldFix = true;
                        }
                        // Or if it contains hidden iframes
                        if (node.querySelectorAll && 
                            node.querySelectorAll('iframe[aria-hidden="true"], iframe.hidden, iframe[class*="hidden"]').length > 0) {
                            shouldFix = true;
                        }
                    }
                });
            }
        });
        
        if (shouldFix) {
            fixHiddenIframeAccessibility();
        }
    });
    
    // Observe the document body for new iframes
    iframeObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Prevent keyboard focus inside containers hidden from assistive tech.
    // This keeps hidden slides/popups from trapping silent focus targets.
    const hiddenContainerSelector = '.slideshow-slide[aria-hidden], .emotive-popup-root[aria-hidden], [data-acsb-hidden][aria-hidden]';
    const hiddenFocusableSelector = 'a[href], button, input, select, textarea, [tabindex]';

    function syncHiddenContainerFocusability() {
        return; // TEMP: disabled — was applying inert to hidden carousel slides and blocking link clicks
        const hiddenContainers = document.querySelectorAll(hiddenContainerSelector);

        hiddenContainers.forEach(function(container) {
            const isHidden = container.getAttribute('aria-hidden') === 'true' || container.getAttribute('data-acsb-hidden') === 'true';
            const focusables = container.querySelectorAll(hiddenFocusableSelector);

            if (isHidden) {
                container.setAttribute('inert', '');
            } else {
                container.removeAttribute('inert');
            }

            focusables.forEach(function(element) {
                if (isHidden) {
                    if (!element.hasAttribute('data-prev-tabindex') && element.hasAttribute('tabindex')) {
                        element.setAttribute('data-prev-tabindex', element.getAttribute('tabindex'));
                    }
                    element.setAttribute('tabindex', '-1');
                } else if (element.hasAttribute('data-prev-tabindex')) {
                    element.setAttribute('tabindex', element.getAttribute('data-prev-tabindex'));
                    element.removeAttribute('data-prev-tabindex');
                } else if (element.getAttribute('tabindex') === '-1') {
                    element.removeAttribute('tabindex');
                }
            });
        });
    }

    syncHiddenContainerFocusability();

    const hiddenContainerObserver = new MutationObserver(function(mutations) {
        let shouldSync = false;

        for (let i = 0; i < mutations.length; i += 1) {
            const mutation = mutations[i];
            if (mutation.type === 'attributes') {
                shouldSync = true;
                break;
            }

            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                shouldSync = true;
                break;
            }
        }

        if (shouldSync) {
            syncHiddenContainerFocusability();
        }
    });

    hiddenContainerObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'data-acsb-hidden']
    });

    // Ensure injected accessibility trigger buttons have an accessible name.
    function syncAccessibilityTriggerLabel() {
        const triggers = document.querySelectorAll('.acsb-trigger[role="button"]');

        triggers.forEach(function(trigger) {
            if (!trigger.getAttribute('aria-label') && !trigger.getAttribute('aria-labelledby')) {
                trigger.setAttribute('aria-label', 'Open accessibility options');
            }
        });
    }

    syncAccessibilityTriggerLabel();

    const accessibilityTriggerObserver = new MutationObserver(function(mutations) {
        let shouldSync = false;

        for (let i = 0; i < mutations.length; i += 1) {
            const mutation = mutations[i];

            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                shouldSync = true;
                break;
            }

            if (mutation.type === 'attributes' && mutation.target.classList && mutation.target.classList.contains('acsb-trigger')) {
                shouldSync = true;
                break;
            }
        }

        if (shouldSync) {
            syncAccessibilityTriggerLabel();
        }
    });

    accessibilityTriggerObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['role', 'aria-label', 'aria-labelledby']
    });

    // Keep slideshow slides mapped to a valid widget role so aria-labelledby
    // remains valid even when third-party scripts mutate attributes.
    function syncSlideshowSlideRoles() {
        const slides = document.querySelectorAll('[data-slideshow-slide]');

        slides.forEach(function(slide) {
            if (!slide.getAttribute('role')) {
                slide.setAttribute('role', 'tabpanel');
            }
        });
    }

    syncSlideshowSlideRoles();

    const slideshowRoleObserver = new MutationObserver(function(mutations) {
        let shouldSync = false;

        for (let i = 0; i < mutations.length; i += 1) {
            const mutation = mutations[i];
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                shouldSync = true;
                break;
            }

            if (
                mutation.type === 'attributes' &&
                mutation.target.hasAttribute &&
                mutation.target.hasAttribute('data-slideshow-slide')
            ) {
                shouldSync = true;
                break;
            }
        }

        if (shouldSync) {
            syncSlideshowSlideRoles();
        }
    });

    slideshowRoleObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['role', 'aria-labelledby']
    });

    // Normalize orphan <li> elements generated by third-party/runtime markup.
    // Any direct child <li> nodes outside of UL/OL/MENU are grouped into a UL.
    function normalizeOrphanListItems() {
        const allListItems = document.querySelectorAll('li');
        const parentMap = new Map();

        allListItems.forEach(function(listItem) {
            const parent = listItem.parentElement;
            if (!parent) {
                return;
            }

            const parentTag = parent.tagName;
            if (parentTag === 'UL' || parentTag === 'OL' || parentTag === 'MENU') {
                return;
            }

            if (!parentMap.has(parent)) {
                parentMap.set(parent, []);
            }

            parentMap.get(parent).push(listItem);
        });

        parentMap.forEach(function(orphanListItems, parent) {
            const directChildren = Array.prototype.slice.call(parent.children);
            let index = 0;

            while (index < directChildren.length) {
                const node = directChildren[index];
                if (node.tagName !== 'LI') {
                    index += 1;
                    continue;
                }

                const listWrapper = document.createElement('ul');
                listWrapper.setAttribute('data-a11y-generated-list', 'true');

                while (index < directChildren.length && directChildren[index].tagName === 'LI') {
                    listWrapper.appendChild(directChildren[index]);
                    index += 1;
                }

                const nextSibling = directChildren[index] || null;
                parent.insertBefore(listWrapper, nextSibling);
            }
        });
    }

    normalizeOrphanListItems();

    const orphanListObserver = new MutationObserver(function(mutations) {
        let shouldNormalize = false;

        for (let i = 0; i < mutations.length; i += 1) {
            const mutation = mutations[i];
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                shouldNormalize = true;
                break;
            }
        }

        if (shouldNormalize) {
            normalizeOrphanListItems();
        }
    });

    orphanListObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Convert orphan <summary> elements into neutral containers when they
    // are not children of <details>, avoiding broken "collapsed group" output.
    function normalizeOrphanSummaryElements() {
        const orphanSummaries = document.querySelectorAll('summary:not(details > summary)');

        orphanSummaries.forEach(function(summary) {
            const replacement = document.createElement('div');
            replacement.setAttribute('data-a11y-summary-normalized', 'true');

            const className = summary.getAttribute('class');
            if (className) {
                replacement.setAttribute('class', className);
            }

            // Preserve non-semantic attributes used for styling/hooks.
            Array.prototype.slice.call(summary.attributes).forEach(function(attribute) {
                const name = attribute.name;
                if (name === 'class') {
                    return;
                }

                if (name === 'role' || name.indexOf('aria-') === 0) {
                    return;
                }

                replacement.setAttribute(name, attribute.value);
            });

            while (summary.firstChild) {
                replacement.appendChild(summary.firstChild);
            }

            summary.parentNode.replaceChild(replacement, summary);
        });
    }

    normalizeOrphanSummaryElements();

    const orphanSummaryObserver = new MutationObserver(function(mutations) {
        let shouldNormalize = false;

        for (let i = 0; i < mutations.length; i += 1) {
            const mutation = mutations[i];
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                shouldNormalize = true;
                break;
            }
        }

        if (shouldNormalize) {
            normalizeOrphanSummaryElements();
        }
    });

    orphanSummaryObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Fix ARIA presentational-children issues from anchor elements forced to
    // role="button" in navigation/menu markup.
    function normalizeAnchorButtonRoles() {
        const anchorButtons = document.querySelectorAll('a[role="button"]');

        anchorButtons.forEach(function(anchor) {
            const href = (anchor.getAttribute('href') || '').trim();
            const isPlaceholderLink = href === '' || href === '#';

            // Placeholder links acting as toggles should be actual buttons.
            if (isPlaceholderLink) {
                const button = document.createElement('button');
                button.setAttribute('type', 'button');

                Array.prototype.slice.call(anchor.attributes).forEach(function(attribute) {
                    const name = attribute.name;
                    if (name === 'href') {
                        return;
                    }
                    button.setAttribute(name, attribute.value);
                });

                while (anchor.firstChild) {
                    button.appendChild(anchor.firstChild);
                }

                anchor.parentNode.replaceChild(button, anchor);
                return;
            }

            // Real links should keep link semantics rather than button role.
            anchor.removeAttribute('role');
        });
    }

    normalizeAnchorButtonRoles();

    const anchorButtonRoleObserver = new MutationObserver(function(mutations) {
        let shouldNormalize = false;

        for (let i = 0; i < mutations.length; i += 1) {
            const mutation = mutations[i];
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                shouldNormalize = true;
                break;
            }

            if (
                mutation.type === 'attributes' &&
                mutation.target.tagName === 'A' &&
                mutation.attributeName === 'role'
            ) {
                shouldNormalize = true;
                break;
            }
        }

        if (shouldNormalize) {
            normalizeAnchorButtonRoles();
        }
    });

    anchorButtonRoleObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['role']
    });

    // PDP description: line-clamp with Read more / Read less (CB-aligned).
    function initProductDescriptionReadmore(root) {
        const scope = root || document;

        scope.querySelectorAll('[data-product-description-readmore]:not([data-readmore-initialized])').forEach(function(wrapper) {
            const content = wrapper.querySelector('[data-product-description-readmore-content]');
            const toggle = wrapper.querySelector('[data-product-description-readmore-toggle]');
            if (!content || !toggle) return;

            wrapper.setAttribute('data-readmore-initialized', 'true');

            const readMoreLabel = toggle.querySelector('[data-readmore-label]');
            const readLessLabel = toggle.querySelector('[data-readless-label]');
            const lineLimit = parseInt(wrapper.getAttribute('data-line-limit') || '5', 10);

            content.style.setProperty('--product-description-line-clamp', String(lineLimit));

            function needsReadMore() {
                if (!content.textContent || !content.textContent.trim()) {
                    return false;
                }

                const wasCollapsed = content.classList.contains('is-collapsed');
                content.classList.remove('is-collapsed');
                const fullHeight = content.scrollHeight;

                if (wasCollapsed) {
                    content.classList.add('is-collapsed');
                }

                const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight);
                if (!lineHeight || Number.isNaN(lineHeight)) {
                    return fullHeight > content.clientHeight + 1;
                }

                return fullHeight > lineHeight * lineLimit + 2;
            }

            function updateToggleVisibility() {
                if (!content.classList.contains('is-collapsed')) {
                    toggle.hidden = false;
                    return;
                }

                toggle.hidden = !needsReadMore();
            }

            function setExpanded(expanded) {
                content.classList.toggle('is-collapsed', !expanded);
                toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

                if (readMoreLabel) {
                    readMoreLabel.hidden = expanded;
                }

                if (readLessLabel) {
                    readLessLabel.hidden = !expanded;
                }
            }

            toggle.addEventListener('click', function() {
                const expanded = content.classList.contains('is-collapsed');
                setExpanded(expanded);
            });

            setExpanded(false);
            updateToggleVisibility();

            window.addEventListener('resize', updateToggleVisibility);
        });
    }

    initProductDescriptionReadmore();

    const productDescriptionReadmoreObserver = new MutationObserver(function(mutations) {
        let shouldInit = false;

        for (let i = 0; i < mutations.length; i += 1) {
            const mutation = mutations[i];
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                shouldInit = true;
                break;
            }
        }

        if (shouldInit) {
            initProductDescriptionReadmore();
        }
    });

    productDescriptionReadmoreObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    });
})();
  
